import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { User } from '@navfleet/client/user/domain/models';
import { environment } from '@navfleet/shared/core/environment';

const USER_URL = `${environment.NAVFLEET_BACKEND}/api/v1/Users`;

@Injectable({
    providedIn: 'root',
})
export class UserApi {
    private http = inject(HttpClient);

    public getUsers() {
        return this.http.get<User[]>(USER_URL);
    }
}
